import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppSlice {
  hostPath: string;
}
const initialState: AppSlice = {
  hostPath: "",
};

export const appSlice = createSlice({
  name: "appstore",
  initialState,
  reducers: {
    setHostPath: (state, action: PayloadAction<string>) => {
      state.hostPath = action.payload;
    },
    resetAppState: () => initialState,
  },
});

export const { setHostPath, resetAppState } = appSlice.actions;

export default appSlice.reducer;
